<div class="d-flex flex-column">
    <div class="d-flex align-items-center justify-content-between mt-4">
        <div [ngClass]="isEditing() ? 'w-60' : 'w-80'">
            <contact-directories-details-initials [contact]="contact()" />
        </div>
        @if (isEditing()) {
            <div class="d-flex align-items-center w-35">
                <telxl-button
                    class="w-100"
                    colour="light"
                    (buttonClick)="performFormAction('cancel')"
                >
                    Cancel
                </telxl-button>
                <telxl-button
                    colour="primary"
                    class="w-100 ps-2"
                    [outline]="true"
                    [disabled]="(canSave$ | async) === false"
                    (buttonClick)="performFormAction('save')"
                >
                    Save
                </telxl-button>
            </div>
        } @else {
            <div class="d-flex align-items-center w-15">
                @if (hasCanUpdatePermission) {
                    <telxl-button
                        class="w-100"
                        colour="light"
                        (buttonClick)="performEdit()"
                    >
                        Edit
                    </telxl-button>
                }
            </div>
        }
    </div>
</div>
<div class="mt-4">
    <contact-directories-details-form
        [contact]="contact()"
        (updated)="onUpdated($event)"
    />
</div>
